import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';
import Input from '../../../shared/form-elements/input';
import { formatMoney } from '../../../shared/format';

const Form = props => {
	const submit = data => props.pointTransactionFormSubmit(data);

	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className='payouts-form__main-fields'>
					<div className='ui-form__element affiliates'>
						<Field
							name='affiliate_id'
							placeholder={props.intl('Affiliate')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.affiliatesLookups}
							disabled={true}
						/>
					</div>
					<div className='ui-form__element amount'>
						<Field
							name='amount'
							placeholder={props.intl('Amount')}
							normalize={value => formatMoney(value, true)}
							component={Input}
						/>
					</div>
					<div className='ui-form__element amount'>
						<Field
							name='conversion_geo'
							placeholder={props.intl('Geo')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.geosConversionsLookups}
						/>
					</div>
					<div className='ui-form__element comment'>
						<Field
							name='comment'
							placeholder={props.intl('Comment')}
							component={Input}
						/>
					</div>
				</div>
				<button
					className='ui-btn ui-btn-primary apply'
					type='submit'
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.togglePointTransactionForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	pointsTransactionFormData: PropTypes.object,
	handleSubmit: PropTypes.func,
	pointTransactionFormSubmit: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	geosConversionsLookups: PropTypes.object,
	transactionFormGetAffiliateSettings: PropTypes.func,
	togglePointTransactionForm: PropTypes.func,
	intl: PropTypes.func,
	form: PropTypes.string,
	fetchData: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Transfer affiliate\'s points')}
		body={Form(props)}
		isOpen={props.pointTransactionShouldShowStatus}
		onClose={props.togglePointTransactionForm}
		className='form-modal'
	/>;

Main.propTypes = {
	togglePointTransactionForm: PropTypes.func,
	pointTransactionShouldShowStatus: PropTypes.bool,
	intl: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/points-transaction-form/main.js